// extracted by mini-css-extract-plugin
module.exports = {"infoContainer":"Info_infoContainer__3ivOg"};